import { useAppSelector } from 'app/hooks';
import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Button, { ButtonWrapper } from 'blocks/Button';
import Card from 'blocks/Card';
import Row from 'blocks/Row';
import { PageTitle } from 'blocks/Text';
import Form, { SelectField } from 'components/Form';
import Loading from 'components/Loading';
import WithSidebar from 'layouts/WithSidebar';
import DepartureArrivalField from 'pages/services/FreeTicket/form/components/flightForm/departureArrivalField';
import { callbackPropsDepartureArrivalField } from 'pages/services/FreeTicket/form/components/flightForm/departureArrivalField/departureArrivalField.interface';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getAirlineService } from 'services/Airline.service';
import { getPublicTiersDataService } from 'services/publicData.service';
import {
  airlineLoadingState,
  airlineState,
  setAirline,
  setAirlinesError,
  setAirlinesLoading,
} from 'store/airlineData/airlineDataSlice';
import {
  publicTiersState,
  setPublicTiersData,
  setPublicTiersDataError,
  setPublicTiersDataLoading,
} from 'store/publicData/publicDataSlice';
import urls from 'utils/urls';
import {
  CalculateEarnMiles,
  CalculateEarnMilesItem,
  CalculateSpendMiles,
  CalculationFormModel,
} from './calculation.interface';
import * as S from './calculation.styles';
const Calculation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    register,
    getValues,
    formState: { errors },
    setValue,
    watch,
  } = useForm<CalculationFormModel>();
  const selectedTier = useRef('');
  const selectedAirline = useRef('');
  const [loading, setLoading] = useState(false);
  const [calculateType, setCalculateType] = useState([
    { name: t('pages.miles.calculation.tabs.earn'), value: 'earn', active: true },
    { name: t('pages.miles.calculation.tabs.spend'), value: 'spend', active: false },
  ]);
  const [results, setResults] = useState<CalculateEarnMilesItem[]>([]);
  const [resultSpend, setResultSpend] = useState<any>([]);
  const PublicTiers = useAppSelector(publicTiersState);
  const airlineProducts = useAppSelector(airlineState);
  const airlineProductLoading = useAppSelector(airlineLoadingState);
  const [newFormAirlineProducts, setNewFormAirlineProducts] = useState<any>();
  useEffect(() => {
    getPublicData();
    getAirline();
  }, []);

  useEffect(() => {
    const newAirlineProducts =
      airlineProducts && airlineProducts.map((item) => ({ title: item.name, value: item.id, objectValue: item }));
    setNewFormAirlineProducts(newAirlineProducts);
  }, [airlineProducts]);

  const getPublicData = async () => {
    dispatch(setPublicTiersDataLoading());
    getPublicTiersDataService()
      .then((res) => {
        dispatch(setPublicTiersData(res.data));
      })
      .catch((ex) => {
        dispatch(setPublicTiersDataError(ex));
      });
  };

  useEffect(() => {
    console.log(resultSpend);
  }, [resultSpend]);
  const getAirline = async () => {
    dispatch(setAirlinesLoading());
    getAirlineService()
      .then((res) => {
        dispatch(setAirline(res.data));
      })
      .catch((ex) => {
        dispatch(setAirlinesError(ex));
      });
  };

  const calculate = async () => {
    const calculateActive = calculateType.find((i) => i.active)?.value;
    if (calculateActive == 'spend') {
      const data = getValues();
      setLoading(true);

      let params = `?departure=${data.from}&destination=${data.to}&tierId=${data.tier}&airlineProductId=${data.airline}&page=0`;

      // if(selectedTier.current) params += `&tierId=${selectedTier.current}`

      axios
        .get(urls.calculateSpend + params)
        .then((res) => {
          const data = res.data.response as CalculateSpendMiles;
          if (!data.data.length) toast.error('Not Found Any Result');

          setResultSpend(data);
          return;
        })
        .catch((ex) => {
          return toast.error(ex?.response?.data?.message || 'We have problem');
        })
        .finally(() => setLoading(false));
    } else {
      const data = getValues();
      setLoading(true);

      let params = `?departure=${data.from}&destination=${data.to}&tierId=${data.tier}&page=0`;

      // if(selectedTier.current) params += `&tierId=${selectedTier.current}`

      axios
        .get(urls.calculate + params)
        .then((res) => {
          const data = res.data.response as CalculateEarnMiles;
          if (!data.data.length) toast.error('Not Found Any Result');
          setResults(data.data);
          return;
        })
        .catch((ex) => {
          return toast.error(ex?.response?.data?.message || 'We have problem');
        })
        .finally(() => setLoading(false));
    }
  };

  const handleClickTab = (name: string): void => {
    setCalculateType(
      calculateType.map((item) => {
        return {
          ...item,
          active: item.name === name,
        };
      })
    );
  };

  const getCalculationType = () => calculateType.filter((item) => item.active)[0].value;

  const onSelectTier = (objectValue: any) => {
    selectedTier.current = objectValue.id;
  };

  const onSelectAirLine = (objectValue: any) => {
    selectedAirline.current = objectValue.id;
  };
  const changeArrivalDeparture = (data: callbackPropsDepartureArrivalField) => {
    if (data.departure) {
      setValue('from', data.departure.code);
    }
    if (data.arrival) {
      setValue('to', data.arrival.code);
    }
  };

  const prepareEarnTab = () => {
    return results
      .filter((item) => item.earnRewardMilage)
      .map((item) => {
        const items = [
          {
            text: t('pages.miles.calculation.earn.tireMiles', { miles: item.earnTierMilage }),
            color: 'blue',
          },
          {
            text: t('pages.miles.calculation.earn.rewardMiles', { miles: item.earnRewardMilage }),
            color: 'green',
          },
        ];
        return Item(item.RBD, items);
      });
  };

  const prepareUsageTab = () => {
    console.log(resultSpend);

    return resultSpend?.data?.map((item) => {
      const items = [
        {
          text: t('pages.miles.calculation.spend.rewardMiles', {
            miles: item.rewardMilage,
          }),
          color: 'red',
        },
      ];
      return Item(item.RBD, items);
    });
  };

  const Item = (RBD: string, texts: Array<{ color: string; text: string }>) => (
    <S.Item key={RBD}>
      <Card space="sm">
        <S.Row>
          <S.Content>{t('pages.miles.calculation.earn.flightClass', { RBD: RBD })}</S.Content>
          {texts.map((e) => (
            <S.Content $color={e.color as 'blue' | 'red' | 'green'}>{e.text}</S.Content>
          ))}
        </S.Row>
      </Card>
    </S.Item>
  );

  return (
    <WithSidebar>
      <S.Wrapper>
        <PageTitle>{t('pages.miles.calculation.title')}</PageTitle>

        {!PublicTiers.loading ? (
          <BoxWrapper>
            <Row>
              {calculateType.map((item, index) => (
                <S.Tab $active={item.active} key={index} onClick={() => handleClickTab(item.name)}>
                  {item.name}
                </S.Tab>
              ))}
            </Row>
            <Card boxShadow="low">
              <Form>
                <S.InputWrapper $width={calculateType.find((i) => i.active)?.value}>
                  <SelectField
                    label={t('pages.miles.calculation.form.fields.tierStatus.label')}
                    placeholder={t('pages.miles.calculation.form.fields.tierStatus.label')}
                    menu={PublicTiers.data ? PublicTiers.data : []}
                    onChange={(value: string) => {
                      setValue('tier', value);
                    }}
                    onSelect={onSelectTier}
                  />
                  {!airlineProductLoading && calculateType.find((i) => i.active)?.value == 'spend' && (
                    <SelectField
                      label={t('pages.miles.calculation.form.fields.airlineStatus.label')}
                      placeholder={t('pages.miles.calculation.form.fields.airlineStatus.label')}
                      menu={newFormAirlineProducts ? newFormAirlineProducts : []}
                      onChange={(value: string) => {
                        setValue('airline', value);
                      }}
                      onSelect={onSelectAirLine}
                    />
                  )}
                  <S.DepartureArrival>
                    <DepartureArrivalField onChange={(data) => changeArrivalDeparture(data)} />
                  </S.DepartureArrival>
                </S.InputWrapper>

                <S.ButtonWrapper as={ButtonWrapper} justify="flex-end">
                  <S.Button as={Button} loading={loading} onClick={calculate}>
                    {t('pages.miles.calculation.form.submitCTA')}
                  </S.Button>
                </S.ButtonWrapper>
              </Form>
            </Card>
          </BoxWrapper>
        ) : (
          <Loading fullScreen={false} />
        )}

        <BoxWrapper>
          {(results.length || resultSpend?.data?.length) && (
            <Card boxShadow="low">
              {/* <Title size="small" className='box-title'>One way</Title> */}

              {getCalculationType() === 'earn' ? prepareEarnTab() : prepareUsageTab()}
            </Card>
          )}
        </BoxWrapper>
      </S.Wrapper>
    </WithSidebar>
  );
};

export default Calculation;
